import Skeleton from "react-loading-skeleton";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";

import "./styles.sass";

const SkeletonGameList = () => {
  const { isCustomBreakpointSmaller } = useBreakpoint(1370);

  const count = isCustomBreakpointSmaller ? 21 : 15;

  return (
    <div className="SkeletonGameList">
      <div className="SkeletonGameList__grid">
        <Skeleton className="SkeletonGameList__card" count={count} inline />
      </div>
      <div className="SkeletonGameList__more">
        <Skeleton width="100%" height={52} />
      </div>
    </div>
  );
};

export default SkeletonGameList;
